import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Grid, Icon, Modal,
  Form,
  Select,
} from 'semantic-ui-react'

import './PreselectCRUD.css'

import API from '../../../services/Api'

class PreselectCRUD extends Component {
  static propTypes = {
    productId: PropTypes.number.required,
  }

  state = {
    preselects: [],
    openForm: false,
    selectedPreselect: null,
  }

  componentDidMount() {
    API.getPreselectForProduct(this.props.productId).then(({ data: { preselect } }) => {
      this.setState({ preselects: preselect })
    })
  }

  openForm = () => {
    this.setState({
      openForm: true,
    })
  }

  removePreselect = preselectId => {
    let preselects = this.state.preselects.filter(
      e => e.id !== preselectId,
    )
    this.setState({
      preselects,
    })
  }

  editPreselect = preselectId => {
    const preselect = this.state.preselects.find(({ id }) => id === preselectId)
    if (preselect != null) {
      this.setState({
        selectedPreselect: preselect,
        openForm: true,
      })
    }
  }

  createNewPreselect = (newPreselect) => {
    API.createPreselectForProduct(this.props.productId, newPreselect)
      .then(() => {
        API.getPreselectForProduct(this.props.productId).then(({ data: { preselect } }) => {
          this.setState({ preselects: preselect })
        })
      })
  }

  modifyPreselect = newPreselect => {
    API.modifyPreselectForProduct(newPreselect.id, newPreselect)
      .then(() => {
        API.getPreselectForProduct(this.props.productId).then(({ data: { preselect } }) => {
          this.setState({ preselects: preselect })
        })
      })
  }

  render() {
    return (
      <div className="dashboard">
        <div className="addEvent">
          <Button onClick={() => this.openForm()} alt="createEvent">
            Ajouter une présélection
          </Button>
        </div>

        <div className="eventList">
          <Grid columns="equal" divided style={{ height: '7em' }}>
            <Grid.Row>
              <Grid.Column>
                <h3>Product type</h3>
              </Grid.Column>
              <Grid.Column>
                <h3>Installation</h3>
              </Grid.Column>
              <Grid.Column>
                <h3>Chevrons</h3>
              </Grid.Column>
              <Grid.Column>
                <h3>Epaisseur</h3>
              </Grid.Column>
              <Grid.Column>
                <h3>R</h3>
              </Grid.Column>
              <Grid.Column>
                <h3>Editer</h3>
              </Grid.Column>
              <Grid.Column>
                <h3>Supprimer</h3>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          {this.state.preselects.map(p => <Preselect
            preselect={p}
            removePreselect={this.removePreselect}
            editPreselect={this.editPreselect}
          />)}
        </div>

        <Modal
          defaultOpen={false}
          open={this.state.openForm}
          onClose={() => {
            this.setState({
              selectedPreselect: null,
              openForm: false,
            })
          }}
        >
          <PreselectForm
            preselect={this.state.selectedPreselect}
            createNewPreselect={this.createNewPreselect}
            modifyPreselect={this.modifyPreselect}
          />
        </Modal>
      </div>
    )
  }
}

class Preselect extends Component {
  static propTypes = {
    preselect: PropTypes.object.required,
    removePreselect: PropTypes.func.required,
    editPreselect: PropTypes.func.required,
  }

  static solution = {
    1: 'CA standard',
    2: 'CA RT max',
    3: 'CA RT plus',
    4: 'IME standard',
    5: 'IME RT max',
    6: 'IME RT plus',
    7: 'CP standard',
    8: 'CP RT plus',
    9: 'CP RT Max',
    10: 'CP Thermo Loft'
  }

  deletePreselect = preselectId => {
    API.deletePreselectForProduct(preselectId)
      .then(() => {
        this.props.removePreselect(preselectId)
      })
  }

  render() {
    const { preselect } = this.props

    return (
      <Grid columns="equal" divided>
        <Grid.Row id="rowProduct">
          <Grid.Column>
            <h3>{Preselect.solution[preselect.solution_id]}</h3>
          </Grid.Column>
          <Grid.Column>
            <h3>{preselect.monobicouche === 1 ? 'monocouche' : 'bicouche'}</h3>
          </Grid.Column>
          <Grid.Column>
            <h3>{preselect.entreousouschevron === 1 ? 'entre' : 'sous'}</h3>
          </Grid.Column>
          <Grid.Column>
            <h3>{preselect.height}</h3>
          </Grid.Column>
          <Grid.Column>
            <h3>{preselect.r}</h3>
          </Grid.Column>
          <Grid.Column>
            <div className="eventItem">
              <div className="edit">
                <Icon
                  circular
                  name="edit"
                  color="teal"
                  alt="edit"
                  onClick={() => this.props.editPreselect(preselect.id)}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="eventItem">
              <div className="delete">
                <Icon
                  circular
                  name="trash alternate"
                  color="red"
                  alt="delete"
                  onClick={() => this.deletePreselect(preselect.id)}
                />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

class PreselectForm extends Component {
  thickness = [
    60,
    80,
    100,
    120,
    140,
    160,
    180,
    200,
    220,
    225,
    270,
    280,
    300,
    315,
    320,
    360,
    405,
    450,
    495,
    540,
    585,
    630,
    675,
  ]
  static propTypes = {
    preselect: PropTypes.object,
    createNewPreselect: PropTypes.func.required,
    modifyPreselect: PropTypes.func.required,
  }

  constructor(props) {
    super(props)

    const stepOptions = [];

    for (let i = 2; i <= 6; i += 0.05) {
      stepOptions.push(parseFloat(i).toFixed(2));
    }

    for (let i = 6.5; i <= 12; i += 0.5 ) {
      stepOptions.push(parseFloat(i).toFixed(2));
    }

    for (let i = 13; i <= 15; i++) {
      stepOptions.push(parseFloat(i).toFixed(2));
    }

    if (this.props.preselect == null) {
      this.state = {
        stepOptions,
        preselect: {
          solution_id: null,
          monobicouche: 1,
          entreousouschevron: 1,
          height: 60,
          r: 6,
        },
      }
    } else {
      this.state = {
        stepOptions,
        preselect: {
          ...this.props.preselect,
          height: Number(this.props.preselect.height),
          r: Number(this.props.preselect.r),
        },
      }
    }
  }

  changeVal = key => (_, { value }) => {
    this.setState({
      preselect: {
        ...this.state.preselect,
        [key]: value,
      },
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    if (this.props.preselect == null) {
      this.props.createNewPreselect(this.state.preselect)
    } else {
      this.props.modifyPreselect(this.state.preselect)
    }
  }

  render() {
    const { stepOptions } = this.state;

    return (
      <div
        className="eventForm"
        style={{
          backgroundColor: 'white',
          position: 'unset',
          width: '100%',
          margin: 0,
        }}
      >
        <Form onSubmit={this.handleSubmit}>
          <Form.Select
            value={this.state.preselect.solution_id}
            options={[
              { text: 'CA standard', value: 1 },
              { text: 'CA RT max', value: 2 },
              { text: 'CA RT plus', value: 3 },
              { text: 'IME standard', value: 4 },
              { text: 'IME RT max', value: 5 },
              { text: 'IME RT plus', value: 6 },
              { text: 'CP standard', value: 7 },
              { text: 'CP RT plus', value: 8 },
              { text: 'CP RT Max', value: 9},
              { text: 'CP Thermo Loft', value: 10},
            ]}
            label='Product type'
            onChange={this.changeVal('solution_id')}
          />
          <Form.Select
            value={this.state.preselect.monobicouche}
            options={[
              { text: 'monocouche', value: 1 },
              { text: 'bicouche', value: 2 },
            ]}
            label='Installation'
            onChange={this.changeVal('monobicouche')}
          />
              <Form.Select
                value={this.state.preselect.entreousouschevron}
                options={[
                  { text: 'entre', value: 1 },
                  { text: 'sous', value: 2 },
                ]}
                label='Chevrons'
                onChange={this.changeVal('entreousouschevron')}
              />
          {
            this.state.preselect.monobicouche === 2 && <Form.Select
              value={this.state.preselect.height}
              options={
                this.thickness.map(val => (
                  {
                    text: val,
                    value: val,
                  }
                ))
              }
              label='Epaisseur'
              onChange={this.changeVal('height')}
            />
          }
          <Form.Select
            value={this.state.preselect.r}
            options={stepOptions.map(val => (
              {
                text: val,
                value: val,
              }
            ))}
            label='R'
            onChange={this.changeVal('r')}
          />
          <Form.Button fluid content="Submit" />
        </Form>
      </div>
    )
  }
}

export default withRouter(PreselectCRUD)



// WEBPACK FOOTER //
// ./src/components/Protected/Article/PreselectCRUD.jsx